import type { VueConstructor } from 'vue';

function setPositionRelative(el: HTMLElement, relative: boolean) {
  if (relative) {
    el.style.position = 'relative';
  } else if (el.style.removeProperty) {
    el.style.removeProperty('position');
  }
}

export function registerAsyncBlockDirective(Vue: VueConstructor) {
  Vue.directive('asyncBLock', {
    inserted(el, { value }) {
      const block = document.createElement('div');
      block.classList.add('asyncLoader');
      block.style.position = 'absolute';
      block.style.width = '100%';
      block.style.height = '100%';
      block.style.background = 'rgba(255,255,255,0.6)';
      block.style.top = '0';
      block.style.left = '0';
      block.style.display = 'flex';
      block.style.justifyContent = 'center';
      block.style.alignItems = 'center';
      block.style.color = 'black';
      block.style.visibility = value == 'true' ? 'visible' : 'hidden';
      block.style.zIndex = '9999';

      block.innerHTML = `<span role="status" class="spinner-border spinner-border-sm">
              <span class="sr-only">Spinning</span>
            </span>`;
      el.append(block);
    },
    update(el, { value }) {
      const loader = el.querySelector('.asyncLoader');
      if (loader instanceof HTMLElement) {
        if (value) {
          setPositionRelative(el as HTMLElement, true);
          loader.style.visibility = 'visible';
        } else {
          setPositionRelative(el as HTMLElement, false);
          loader.style.visibility = 'hidden';
        }
      }
    }
  });
}
